require('./cardSelector.scss');
require('./cardSelector.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const Storage = require('utilities/storage');
const cryptoJS = require('crypto-js');
// @ components
const CardSelectorButton = require('./cardSelectorButton/cardSelectorButton');
import Slider from 'react-slick'; //Si no se importa con ES6 no funciona.
//@utilities
import { FormattedText } from 'core/i18n';
const { recordEvent } = require('utilities/uTagging');
const { PATH_CONFIG_CARD, PAGE_PRODUCT } = require('constants/uTagConstants/paths');

class CardSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOptionId: null,
        };

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.buildFloatingText = this.buildFloatingText.bind(this);
        this.buildSelectedIcon = this.buildSelectedIcon.bind(this);
        this.setOptionId = this.setOptionId.bind(this);
    }

    componentDidMount() {
        const { images, formActions, profileModelCode, profileModelID, disabled, userProfile, onHandleSave } =
            this.props;
        const modelName = profileModelID.split('.')[1];

        images.map((image, index) => {
            if (index == 0 && !userProfile[modelName]) {
                this.setOptionId(image.id);
                formActions.change(profileModelID, image.id);
                formActions.change(profileModelCode, image.code);
                if (!disabled) {
                    onHandleSave({ cardDesignId: image.id });
                }
            }

            if (image.id === userProfile[modelName]) {
                this.setOptionId(image.id);
                formActions.change(profileModelID, image.id);
                formActions.change(profileModelCode, image.code);
            }
        });
    }

    setOptionId(selectedOptionId) {
        this.setState({
            selectedOptionId,
        });
    }

    handleButtonClick(id, url, code) {
        const {
            profileModelCode,
            profileModelID,
            cardImageUrlModel,
            formActions,
            onHandleSave,
            disabled,
            userProfile,
        } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const data = { cardDesignId: id };

        if (!disabled) {
            this.setOptionId(id);
            onHandleSave(data);
            formActions.change(profileModelID, id);
            formActions.change(profileModelCode, code);
            formActions.change(cardImageUrlModel, url);
            Storage.cookies.set('cardImageUrl', url);
            recordEvent(
                PATH_CONFIG_CARD,
                PAGE_PRODUCT,
                'selecciona el diseño de tu tarjeta',
                'selección de tu diseño de tarjeta correcto - ' + code,
                userProfile.recordId,
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
        }
    }

    buildFloatingText(url, imageStyle) {
        return (
            <p className="card-selector__image-container">
                <img src={url} className={imageStyle} />
            </p>
        );
    }

    buildSelectedIcon() {
        return <i className="card-selector__icon-success icon-exito"></i>;
    }

    buildCardSlides() {
        const { images } = this.props;

        return images.map((image, index) => {
            const { id, url, code } = image;
            const isSelected = id === this.state.selectedOptionId;
            const iconStyles = classnames('icon', 'card-selector__icon', {
                'card-selector__icon-selected': isSelected,
            });

            const imageStyle = classnames('card-selector__image', {
                'card-selector__image-selected': isSelected,
            });

            const buttonStyles = classnames('card-selector__button');

            let floatingText;
            let selectedIcon;

            if (url) {
                floatingText = this.buildFloatingText(url, imageStyle);
            }

            if (isSelected) {
                selectedIcon = this.buildSelectedIcon();
            }

            return (
                <button
                    key={index}
                    onClick={() => {
                        // eslint-disable-line
                        this.handleButtonClick(id, url, code);
                    }}
                    className={buttonStyles}
                >
                    <i className={iconStyles}></i>
                    {selectedIcon}
                    {floatingText}
                </button>
            );
        });
    }

    render() {
        const { images, customContentClass, label } = this.props;
        const slidesToShow = 2;
        const arrowButton = images.length > 2 ? <CardSelectorButton /> : null;
        const contentClassName = classnames('card-selector__content', customContentClass);
        const cards = this.buildCardSlides();

        const settings = {
            dots: false,
            slidesToShow,
            nextArrow: arrowButton,
            prevArrow: arrowButton,
            responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }],
        };

        const content = <Slider {...settings}>{cards}</Slider>;

        return (
            <article className="card-selector">
                <header className="card-selector__header">
                    <h6 className="card-selector__title">
                        <FormattedText value={label} />
                    </h6>
                </header>
                <section className={contentClassName}>{content}</section>
            </article>
        );
    }
}

const imagesPrototype = PropTypes.shape({
    code: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
});

CardSelector.propTypes = {
    images: PropTypes.arrayOf(imagesPrototype).isRequired,
    selectedOptionId: PropTypes.string,
    label: PropTypes.string,
    textOverImg: PropTypes.func,
    customContentClass: PropTypes.string,
    slidesToShow: PropTypes.number,
    profileModelID: PropTypes.string,
    profileModelCode: PropTypes.string,
};

CardSelector.defaultProps = {
    images: [],
    numOfSlides: 3,
};

module.exports = CardSelector;
